export const searchUsers = async (apiCall, searchApi) => {
  try {
    const response = await apiCall(searchApi, {
      method: 'GET',
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    return {
      success: true,
      data: data,
      message: data.message
    };
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Toggle follow error:', error);
    }
    
    throw error;
  }
};